import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { isClient } from "~/lib/ssr";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatShortcut = (shortcut: string) => {
  if (!isClient) return shortcut;

  const symbol = navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? "⌘" : "Ctrl+";

  return `${symbol}${shortcut.toUpperCase()}`;
};
